import client from './client';

export async function getMenuList() {
  const res = await client.get('/admin/menu');
  return res.data;
}

export async function getMenuListByRole(roleCode) {
  const res = await client.get(`/admin/menu/role/${roleCode}`);
  return res.data;
}

/** 로그인한 관리자 본인이 접근 가능한 메뉴 목록 (GNB 렌더링용) */
export async function getMyMenus() {
  const res = await client.get('/admin/menu/my');
  return res.data;
}

export async function createMenu(payload) {
  const res = await client.post('/admin/menu', payload);
  return res.data;
}

export async function updateMenu(menuId, payload) {
  const res = await client.put(`/admin/menu/${menuId}`, payload);
  return res.data;
}

export async function deleteMenu(menuId) {
  const res = await client.delete(`/admin/menu/${menuId}`);
  return res.data;
}

export async function grantRoleMenu(roleCode, menuId) {
  const res = await client.post(`/admin/menu/role/${roleCode}/${menuId}`);
  return res.data;
}

export async function revokeRoleMenu(roleCode, menuId) {
  const res = await client.delete(`/admin/menu/role/${roleCode}/${menuId}`);
  return res.data;
}
